import { instanceToPlain } from "class-transformer";

import { BasePeriodCondition } from "./BaseCondition/BasePeriodCondition";

export abstract class DayCondition extends BasePeriodCondition {
  values: Array<string> = []

  async validate(): Promise<boolean> {
    return !!this.values.length
  }

  getModel() {
    return instanceToPlain({
      type: this.type,
      values: this.values
    })
  }

  addValue(newCondition: DayCondition) {
    this.values = [ ...newCondition.values ].sort()
  }

  removeValue(condition: BasePeriodCondition, index?: number) {
    this.values = []
  }

  isEmpty(): boolean {
    return !this.values.length
  }
}
